import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';
import { translate, translationKeys } from 'logic/translations/translations.service';
import { Text } from 'components/text/Text';
import { AppRoute } from 'app/app.route.const';

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  margin: 48px 16px 16px 16px;
  gap: 4px;
`;

const FooterLink = styled(Link)``;

export const MinimalFooterStrip = () => {
  return (
    <Container>
      <FooterLink to={AppRoute.FooterImpressum}>
        <Text size={12} underline color="gray10">
          {translate(translationKeys.footer.links.imprint)}
        </Text>
      </FooterLink>
      <Text>·</Text>
      <FooterLink to={AppRoute.FooterDataProtection}>
        <Text size={12} underline color="gray10">
          {translate(translationKeys.footer.links.dataProtection)}
        </Text>
      </FooterLink>
    </Container>
  );
};
